import { useNavigate, useLocation } from "react-router-dom";
import { Flame, Users, RefreshCw, ShoppingBag, User, BarChart3 } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

const BottomNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const isSeller = user?.interests?.includes("sell");

  const navItems = [
    { path: "/home", icon: Flame, label: "Início" },
    ...(isSeller
      ? [{ path: "/dashboard", icon: BarChart3, label: "Vendas" }]
      : [{ path: "/marketplace", icon: ShoppingBag, label: "Comprar" }]),
    { path: "/exchanges", icon: RefreshCw, label: "Trocas" },
    { path: "/profile", icon: User, label: "Perfil" },
  ];

  const isActive = (path) => {
    if (path === "/home" && location.pathname === "/home") return true;
    if (path !== "/home" && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-[100] bg-[#0a0a0a] border-t border-white/10">
      <div className="flex items-center justify-around h-16 max-w-lg mx-auto px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-all ${
                active ? "text-[#FD5564]" : "text-white/50 hover:text-white/70"
              }`}
              data-testid={`nav-${item.label.toLowerCase()}`}
            >
              <Icon className={`w-5 h-5 mb-1 ${active ? "scale-110" : ""} transition-transform`} />
              <span className="text-[10px] font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
      {/* Safe area padding for iOS */}
      <div className="h-safe-area-inset-bottom bg-[#0a0a0a]" />
    </nav>
  );
};

export default BottomNavigation;
